import React from 'react'
import { Link } from 'react-router-dom'

const SignIn = () => {
    return (
        <div className="flex justify-center items-center">
            {/* Page Body Area */}
            <div className="w-full max-w-full p-6 auth-body border rounded-lg shadow-md">
                <form>
                    <ul className="space-y-6 list-none li_animate">
                        <li className="w-full">
                            <label htmlFor='email' className="block text-lg font-medium mb-2">Email</label>
                            <input
                                type="email"
                                id='email'
                                className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                                placeholder="Enter your email"
                                defaultValue="admin@dashbanker.com"
                                autoComplete='off'
                            />
                        </li>
                        <li className="w-full">
                            <div className="block text-lg">
                                <label htmlFor="password" className="flex justify-between items-center mb-2">
                                    Password
                                    <Link className="text-blue-500 text-sm hover:underline" to="password-reset">
                                        Forgot Password?
                                    </Link>
                                </label>
                            </div>
                            <input
                                type="password"
                                id="password"
                                className="bg-light rounded-lg py-4 px-3 border-transparent focus:border-primary w-full focus:outline-[0.5px] focus:outline-dashed focus:outline-offset-2 focus:outline-gray-600 focus:ring-0"
                                placeholder="Enter your password"
                                defaultValue="admin.dashbanker"
                                autoComplete='off'
                            />
                        </li>
                        <li className="w-full">
                            <div className="flex items-center">
                                <input
                                    className="form-checkbox rounded border-gray-300 text-blue-600 focus:ring-2 focus:ring-blue-500"
                                    type="checkbox"
                                    id="Rememberme"
                                />
                                <label className="ml-2 text-sm text-gray-600" htmlFor="Rememberme">
                                    Remember this Device
                                </label>
                            </div>
                        </li>
                        <li className="w-full mt-8">
                            <Link
                                className="w-full block py-3 text-white bg-blue-600 hover:bg-blue-500 rounded-lg uppercase text-center font-medium tracking-wide"
                                to="/"
                                title="sign in"
                            >
                                Sign In
                            </Link>
                            <Link
                                className="w-full py-3 mt-4 bg-gray-700 hover:bg-gray-800 text-white rounded-lg flex items-center justify-center"
                                to="signin"
                            >
                                <i className="fa fa-google mr-2"></i>
                                <span>Sign in with Google</span>
                            </Link>
                        </li>
                        <li className="w-full text-center mt-4">
                            <span className="text-gray-500">
                                New to DashBanker?
                                <Link className="ml-2 text-blue-500 hover:underline" to="/signup">
                                    Sign up here
                                </Link>
                            </span>
                        </li>
                    </ul>
                </form>
            </div>
        </div>


    )
}

export default SignIn